import React, { useState, useEffect } from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'
import { adminApiAxiosInstance } from '../../services/api'

export const EcosistemaImageSettings = (props) => {
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="testoRental"
          type="text"
          label="testoRental"
          defaultValue={defaultProps['testoRental']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="testoService"
          type="text"
          label="testoService"
          defaultValue={defaultProps['testoService']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="testoGlass"
          type="text"
          label="testoGlass"
          defaultValue={defaultProps['testoGlass']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="testoAssistance"
          type="text"
          label="testoAssistance"
          defaultValue={defaultProps['testoAssistance']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="testoTech"
          type="text"
          label="testoTech"
          defaultValue={defaultProps['testoTech']}
        />
      </ToolbarSection>
    </>
  )
}
